const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      restaurant: 'Notre Restaurant',
      menu: 'La Carte',
      dishes: 'Nos Plats',
      events: 'Événements',
      book: 'Réserver',
      contact: 'Contact',
      bookTable: 'Réserver une table',
      topBarHours: 'Ouvert 7j/7 - Dim-Mer 10h-00h | Jeu-Sam 10h-02h',
    },
    footer: {
      description: "Savourez l'authenticité de la cuisine libanaise dans un cadre chaleureux et convivial au cœur de Genève.",
      contact: 'Contact',
      hours: 'Horaires',
      open7: 'Ouvert 7j/7',
      followUs: 'Suivez-nous',
      navigation: 'Navigation',
      allRights: 'Tous droits réservés.',
      subtitle: 'Restaurant Libanais à Genève',
    },
    home: {
      welcome: 'Bienvenue chez',
      subtitle: "Savourez l'authenticité de la cuisine libanaise au cœur de Genève",
      discoverMenu: 'Découvrir la carte',
      bookTable: 'Réserver une table',
      homemade: 'Fait Maison',
      homemadeDesc: 'Tous nos plats sont préparés avec des ingrédients frais chaque jour',
      generous: 'Généreux',
      generousDesc: 'Des portions généreuses à partager entre amis et en famille',
      ambiance: 'Ambiance',
      ambianceDesc: 'Un cadre chaleureux pour une expérience authentique',
      ourDishes: 'Nos Plats',
      dishesSubtitle: 'Découvrez en images les saveurs authentiques de notre cuisine libanaise',
      viewFullMenu: 'Voir toute la carte',
      whatClientsSay: 'Ce que disent nos clients',
      clientsSubtitle: 'Découvrez les avis de nos clients sur Google',
      googleReviews: 'avis Google',
      viewAllReviews: 'Voir tous les avis',
      leaveReview: 'Laissez-nous un avis',
    },
    menu: {
      title: 'Notre Carte',
      subtitle: "Découvrez l'authenticité de la cuisine libanaise à travers nos mezzés, grillades et spécialités maison",
      downloadPdf: 'Télécharger la carte (PDF)',
      takeaway: 'Tous nos plats peuvent être préparés à emporter',
      allergies: "Allergies ou régimes spéciaux ? N'hésitez pas à nous consulter",
    },
    reservation: {
      title: 'Réserver une table',
      subtitle: 'Rejoignez-nous pour une expérience culinaire inoubliable',
      formTitle: 'Formulaire de réservation',
      fullName: 'Nom complet *',
      email: 'Email *',
      phone: 'Téléphone *',
      guests: 'Nombre de personnes *',
      select: 'Sélectionnez...',
      person: 'personne',
      persons: 'personnes',
      moreThan10: 'Plus de 10 personnes',
      date: 'Date *',
      time: 'Heure *',
      specialRequests: 'Demandes spéciales',
      placeholder: 'Anniversaire, allergies, terrasse, chaise bébé...',
      sending: 'Envoi en cours...',
      submit: 'Réserver ma table',
      emailConfirm: "Vous recevrez un email de confirmation à l'adresse indiquée",
      successMsg: 'Votre réservation a bien été envoyée ! Vous recevrez un email de confirmation.',
      errorMsg: "Erreur lors de l'envoi. Veuillez réessayer ou nous appeler.",
      practicalInfo: 'Informations pratiques',
      hours: 'Horaires',
      open7: 'Ouvert 7j/7',
      address: 'Adresse',
      groups: 'Groupes',
      groupsText: 'Pour les groupes de plus de 10 personnes, contactez-nous directement :',
      cancellation: "Politique d'annulation",
      cancellationText: "Merci de nous prévenir au moins 24h à l'avance en cas d'annulation ou de modification.",
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: "Nous serions ravis d'échanger avec vous",
      coordinates: 'Nos coordonnées',
      address: 'Adresse',
      parkings: 'Parkings à proximité',
      phone: 'Téléphone',
      email: 'Email',
      hours: 'Horaires',
      open7: 'Ouvert 7j/7',
      followUs: 'Suivez-nous',
      sendMessage: 'Envoyez-nous un message',
      fullName: 'Nom complet *',
      emailLabel: 'Email *',
      subject: 'Sujet *',
      selectSubject: 'Sélectionnez un sujet',
      subjectReservation: 'Question sur une réservation',
      subjectMenu: 'Question sur le menu',
      subjectEvent: "Organisation d'événement",
      subjectFeedback: 'Avis / Commentaire',
      subjectOther: 'Autre',
      message: 'Message *',
      messagePlaceholder: 'Votre message...',
      sending: 'Envoi en cours...',
      submit: 'Envoyer le message',
      successMsg: 'Votre message a bien été envoyé ! Nous vous répondrons rapidement.',
      errorMsg: "Erreur lors de l'envoi. Veuillez réessayer.",
      readyToVisit: 'Prêt à nous rendre visite ?',
      waitingForYou: 'Nous vous attendons au 27 rue de Berne à Genève',
      directions: 'Itinéraire',
    },
    events: {
      title: 'Événements & Team Building',
      subtitle: 'Organisez vos moments spéciaux avec une touche libanaise authentique',
      persons: 'personnes',
      included: 'Inclus :',
      requestQuote: 'Demander un devis',
      quoteSubtitle: 'Remplissez le formulaire ci-dessous et nous vous contacterons rapidement avec une offre personnalisée',
      fullName: 'Nom complet *',
      email: 'Email *',
      phone: 'Téléphone *',
      eventType: "Type d'événement *",
      select: 'Sélectionnez...',
      participants: 'Nombre de participants *',
      desiredDate: 'Date souhaitée',
      messageLabel: 'Message / Détails supplémentaires',
      messagePlaceholder: 'Décrivez votre événement, vos attentes, besoins spéciaux...',
      sending: 'Envoi en cours...',
      submit: 'Envoyer la demande de devis',
      successMsg: 'Votre demande de devis a bien été envoyée ! Nous vous contacterons sous 48h.',
      errorMsg: "Erreur lors de l'envoi. Veuillez réessayer.",
      question: 'Une question ?',
      questionSubtitle: 'Notre équipe est à votre disposition pour vous aider à organiser votre événement parfait',
      contactUs: 'Nous contacter',
    },
    presentation: {
      heroTitle: "L'authenticité libanaise au cœur de Genève",
      heroText: "Chez Ya Habibi, nous vous invitons à un voyage culinaire au pays du cèdre. Chaque plat raconte une histoire, celle de traditions ancestrales et de recettes familiales transmises avec amour de génération en génération.",
      discoverMenu: 'Découvrir notre carte',
      yearsExp: "années d'expérience",
      values: 'Nos Valeurs',
      valuesSubtitle: 'Ce qui fait de Ya Habibi un lieu unique',
      passion: 'Passion',
      passionDesc: 'Chaque plat est préparé avec amour et dévouement, comme nous le ferions pour notre propre famille.',
      quality: 'Qualité',
      qualityDesc: 'Nous sélectionnons uniquement les meilleurs ingrédients pour garantir une expérience gustative exceptionnelle.',
      conviviality: 'Convivialité',
      convivialityDesc: 'Notre restaurant est un lieu de partage où chaque client devient un ami.',
      freshness: 'Fraîcheur',
      freshnessDesc: 'Tous nos plats sont préparés quotidiennement avec des produits frais et de saison.',
      ourStory: 'Notre Histoire',
      storyP1: "Ya Habibi est né d'un rêve : celui de partager les saveurs authentiques du Liban avec les Genevois. Notre chef, héritier d'une longue tradition culinaire familiale, a grandi entouré des arômes envoûtants de la cuisine de sa grand-mère dans les montagnes du Mont-Liban.",
      storyP2: "Aujourd'hui, nous perpétuons ces traditions avec fierté, en utilisant des recettes centenaires et des techniques ancestrales pour vous offrir une expérience culinaire véritablement authentique.",
      bullets: [
        'Ingrédients importés directement du Liban',
        'Recettes familiales transmises depuis 3 générations',
        'Pain pita fait maison quotidiennement',
        'Épices fraîchement moulues',
      ],
      quote: "\"La cuisine, c'est l'amour rendu visible\"",
      quoteText: "Chez Ya Habibi, chaque assiette est une déclaration d'amour à notre héritage culinaire. Nous croyons que la nourriture a le pouvoir de rassembler les gens, de créer des souvenirs et de transporter les âmes.",
      quoteAuthor: "— L'équipe Ya Habibi",
      visitUs: 'Venez nous rendre visite',
      visitText: 'Nous serions ravis de vous accueillir et de vous faire découvrir les saveurs du Liban',
      bookTable: 'Réserver une table',
      contactUs: 'Nous contacter',
    },
    history: {
      title: 'Nos Plats',
      subtitle: "L'histoire derrière chaque saveur",
      millennialTitle: 'Une cuisine millénaire',
      millennialText: "La cuisine libanaise est le fruit de milliers d'années d'histoire, influencée par les Phéniciens, les Ottomans et les cultures méditerranéennes. Chaque plat est un témoignage vivant de ce riche héritage culinaire.",
      statYears: "Ans d'histoire",
      statRecipes: 'Recettes traditionnelles',
      statMezzes: 'Types de mezzés',
      statPassion: 'Passion commune',
      ctaTitle: "Envie de goûter à l'histoire ?",
      ctaSubtitle: 'Réservez votre table et découvrez ces saveurs ancestrales',
      bookTable: 'Réserver une table',
      viewMenu: 'Voir la carte',
    },
  },
  en: {
    nav: {
      home: 'Home',
      restaurant: 'Our Restaurant',
      menu: 'Menu',
      dishes: 'Our Dishes',
      events: 'Events',
      book: 'Book',
      contact: 'Contact',
      bookTable: 'Book a table',
      topBarHours: 'Open 7/7 - Sun-Wed 10am-12am | Thu-Sat 10am-2am',
    },
    footer: {
      description: 'Savor authentic Lebanese cuisine in a warm and friendly setting in the heart of Geneva.',
      contact: 'Contact',
      hours: 'Hours',
      open7: 'Open 7 days a week',
      followUs: 'Follow us',
      navigation: 'Navigation',
      allRights: 'All rights reserved.',
      subtitle: 'Lebanese Restaurant in Geneva',
    },
    home: {
      welcome: 'Welcome to',
      subtitle: 'Savor authentic Lebanese cuisine in the heart of Geneva',
      discoverMenu: 'Discover our menu',
      bookTable: 'Book a table',
      homemade: 'Homemade',
      homemadeDesc: 'All our dishes are prepared with fresh ingredients every day',
      generous: 'Generous',
      generousDesc: 'Generous portions to share with friends and family',
      ambiance: 'Atmosphere',
      ambianceDesc: 'A warm setting for an authentic experience',
      ourDishes: 'Our Dishes',
      dishesSubtitle: 'Discover the authentic flavors of our Lebanese cuisine through images',
      viewFullMenu: 'View full menu',
      whatClientsSay: 'What our clients say',
      clientsSubtitle: 'Read our client reviews on Google',
      googleReviews: 'Google reviews',
      viewAllReviews: 'View all reviews',
      leaveReview: 'Leave us a review',
    },
    menu: {
      title: 'Our Menu',
      subtitle: 'Discover authentic Lebanese cuisine through our mezzés, grills and homemade specialties',
      downloadPdf: 'Download menu (PDF)',
      takeaway: 'All our dishes are available for takeaway',
      allergies: 'Allergies or special diets? Feel free to ask us',
    },
    reservation: {
      title: 'Book a table',
      subtitle: 'Join us for an unforgettable culinary experience',
      formTitle: 'Reservation form',
      fullName: 'Full name *',
      email: 'Email *',
      phone: 'Phone *',
      guests: 'Number of guests *',
      select: 'Select...',
      person: 'guest',
      persons: 'guests',
      moreThan10: 'More than 10 guests',
      date: 'Date *',
      time: 'Time *',
      specialRequests: 'Special requests',
      placeholder: 'Birthday, allergies, terrace, baby chair...',
      sending: 'Sending...',
      submit: 'Book my table',
      emailConfirm: 'You will receive a confirmation email at the provided address',
      successMsg: 'Your reservation has been sent! You will receive a confirmation email.',
      errorMsg: 'Error sending. Please try again or call us.',
      practicalInfo: 'Practical information',
      hours: 'Hours',
      open7: 'Open 7 days a week',
      address: 'Address',
      groups: 'Groups',
      groupsText: 'For groups of more than 10, contact us directly:',
      cancellation: 'Cancellation policy',
      cancellationText: 'Please notify us at least 24 hours in advance for cancellations or changes.',
    },
    contact: {
      title: 'Contact us',
      subtitle: 'We would love to hear from you',
      coordinates: 'Our details',
      address: 'Address',
      parkings: 'Nearby parking',
      phone: 'Phone',
      email: 'Email',
      hours: 'Hours',
      open7: 'Open 7 days a week',
      followUs: 'Follow us',
      sendMessage: 'Send us a message',
      fullName: 'Full name *',
      emailLabel: 'Email *',
      subject: 'Subject *',
      selectSubject: 'Select a subject',
      subjectReservation: 'Reservation question',
      subjectMenu: 'Menu question',
      subjectEvent: 'Event organization',
      subjectFeedback: 'Feedback',
      subjectOther: 'Other',
      message: 'Message *',
      messagePlaceholder: 'Your message...',
      sending: 'Sending...',
      submit: 'Send message',
      successMsg: 'Your message has been sent! We will reply soon.',
      errorMsg: 'Error sending. Please try again.',
      readyToVisit: 'Ready to visit us?',
      waitingForYou: 'We look forward to seeing you at 27 rue de Berne in Geneva',
      directions: 'Directions',
    },
    events: {
      title: 'Events & Team Building',
      subtitle: 'Organize your special moments with an authentic Lebanese touch',
      persons: 'people',
      included: 'Included:',
      requestQuote: 'Request a quote',
      quoteSubtitle: 'Fill out the form below and we will contact you shortly with a personalized offer',
      fullName: 'Full name *',
      email: 'Email *',
      phone: 'Phone *',
      eventType: 'Event type *',
      select: 'Select...',
      participants: 'Number of participants *',
      desiredDate: 'Preferred date',
      messageLabel: 'Message / Additional details',
      messagePlaceholder: 'Describe your event, expectations, special needs...',
      sending: 'Sending...',
      submit: 'Send quote request',
      successMsg: 'Your quote request has been sent! We will contact you within 48 hours.',
      errorMsg: 'Error sending. Please try again.',
      question: 'Have a question?',
      questionSubtitle: 'Our team is at your disposal to help you organize your perfect event',
      contactUs: 'Contact us',
    },
    presentation: {
      heroTitle: 'Authentic Lebanese cuisine in the heart of Geneva',
      heroText: 'At Ya Habibi, we invite you on a culinary journey to the land of the cedar. Every dish tells a story of ancestral traditions and family recipes passed down with love from generation to generation.',
      discoverMenu: 'Discover our menu',
      yearsExp: 'years of experience',
      values: 'Our Values',
      valuesSubtitle: 'What makes Ya Habibi a unique place',
      passion: 'Passion',
      passionDesc: 'Every dish is prepared with love and dedication, as we would for our own family.',
      quality: 'Quality',
      qualityDesc: 'We select only the finest ingredients to guarantee an exceptional tasting experience.',
      conviviality: 'Warmth',
      convivialityDesc: 'Our restaurant is a place of sharing where every guest becomes a friend.',
      freshness: 'Freshness',
      freshnessDesc: 'All our dishes are prepared daily with fresh, seasonal ingredients.',
      ourStory: 'Our Story',
      storyP1: "Ya Habibi was born from a dream: to share the authentic flavors of Lebanon with Geneva. Our chef, heir to a long family culinary tradition, grew up surrounded by the enchanting aromas of his grandmother's kitchen in the mountains of Mount Lebanon.",
      storyP2: 'Today, we proudly carry on these traditions, using century-old recipes and ancestral techniques to offer you a truly authentic culinary experience.',
      bullets: [
        'Ingredients imported directly from Lebanon',
        'Family recipes passed down for 3 generations',
        'Homemade pita bread daily',
        'Freshly ground spices',
      ],
      quote: '"Cooking is love made visible"',
      quoteText: 'At Ya Habibi, every plate is a declaration of love to our culinary heritage. We believe food has the power to bring people together, create memories, and transport souls.',
      quoteAuthor: '— The Ya Habibi Team',
      visitUs: 'Come visit us',
      visitText: 'We would be delighted to welcome you and introduce you to the flavors of Lebanon',
      bookTable: 'Book a table',
      contactUs: 'Contact us',
    },
    history: {
      title: 'Our Dishes',
      subtitle: 'The story behind every flavor',
      millennialTitle: 'A Millennia-Old Cuisine',
      millennialText: 'Lebanese cuisine is the fruit of thousands of years of history, influenced by the Phoenicians, the Ottomans and Mediterranean cultures. Every dish is a living testimony to this rich culinary heritage.',
      statYears: 'Years of history',
      statRecipes: 'Traditional recipes',
      statMezzes: 'Types of mezze',
      statPassion: 'Shared passion',
      ctaTitle: 'Want a taste of history?',
      ctaSubtitle: 'Book your table and discover these ancestral flavors',
      bookTable: 'Book a table',
      viewMenu: 'View menu',
    },
  },
};

export default translations;
